'use client'

import { Button } from '@/components/ui/button'
import { PageHeading, BodyText } from '@/components/ui/typography'
import { Link } from '@/i18n/routing'
import { IconAlertTriangle, IconRefresh } from '@tabler/icons-react'
import { useEffect } from 'react'

export default function Error({
  error,
  reset
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Application error:', error)
  }, [error])

  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center px-4">
      <div className="max-w-md space-y-6 text-center">
        <div className="bg-destructive/10 mx-auto flex h-16 w-16 items-center justify-center rounded-full">
          <IconAlertTriangle className="text-destructive h-8 w-8" />
        </div>

        <div className="space-y-2">
          <PageHeading className="text-2xl">Something went wrong</PageHeading>
          <BodyText className="text-muted-foreground">
            An unexpected error occurred. Please try again.
          </BodyText>
          {process.env.NODE_ENV === 'development' && error.message && (
            <code className="bg-muted mt-4 block rounded-md p-3 text-left text-xs">
              {error.message}
            </code>
          )}
        </div>

        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button onClick={() => reset()} className="gap-2">
            <IconRefresh className="h-4 w-4" />
            Try again
          </Button>
          <Button variant="outline" asChild>
            <Link href="/">Go home</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
